import { LANGUAGES } from '@consts/consts';

export const navigatorLanguage = navigator.language.split(/[-_]/)[0];
export const supportedLanguage: string[] = [LANGUAGES.EN, LANGUAGES.PL, LANGUAGES.ES];

export const defaultLanguage = supportedLanguage.includes(navigatorLanguage) ? navigatorLanguage : LANGUAGES.EN;
